module.exports = __webpack_public_path__ + "static/logo-3cd7054a3df5822063e9ad2c8523ce91.svg";